import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=5b45b47d&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"
import style0 from "./Users.vue?vue&type=style&index=0&id=5b45b47d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45b47d",
  null
  
)

export default component.exports